import React from 'react';
import { get } from 'lodash';
import { ManualAlert } from '@conviva/portal-graphql-schema';
import { TableData } from './utils/formatTableData';
import HeaderCell from '@src/pages/Alert/manualAlert/summary/components/AlertTable/HeaderCell';
import { Timestamp, Actions } from '../../../shared';
import { Alert } from 'antd';

const getColumns = ({ nameSearchProps, filterSearchProps }) => {
  return [
    {
      title: 'Name',
      dataKey: 'name',
      key: 'name',
      width: 300,
      sortable: true,
      resizable: true,
      searchProps: nameSearchProps,
      headerRenderer: (props) => <HeaderCell {...props} />,
    },
    {
      title: 'Filter',
      dataKey: 'filter.name',
      key: 'filter.name',
      width: 300,
      sortable: true,
      resizable: true,
      searchProps: filterSearchProps,
      headerRenderer: (props) => <HeaderCell {...props} />,
      cellRenderer: ({ rowData }) => {
        const filterName = get(rowData, ['filter','name'], null);
        return filterName ? <span>{filterName}</span> : (
          <Alert message="Deleted Filter" type="warning" showIcon />
        )
      }
    },
    {
      title: 'Condition',
      dataKey: 'condition',
      key: 'condition',
      width: 300,
      sortable: true,
      resizable: true,
    },
    {
      title: 'Sample',
      dataKey: 'sample',
      key: 'sample',
      width: 200,
      sortable: true,
      resizable: true,
    },
    {
      title: 'Last Event Time',
      dataKey: 'time',
      key: 'time',
      width: 200,
      sortable: true,
      resizable: true,
      cellRenderer: ({ cellData: time, rowData }) => {
        const { source, renderer } = rowData;
        if (renderer) {
          const style = {
            cursor: 'pointer',
          };
          return renderer(style);
        }
        const id = get(source, 'events.0.id', get(source, 'id'));
        return time !== '-' ? <Timestamp id={id} timestamp={time} /> : '-';
      },
    },
    {
      title: '',
      dataKey: '',
      key: 'action',
      width: 50,
      frozen: 'right',
      cellRenderer: ({ rowData }: { rowData: TableData }) => {
        const { parentId = null } = rowData;
        if (parentId !== null) {
          return null;
        }
        const alert = rowData.source as ManualAlert;
        return <Actions alert={alert} />;
      },
    },
  ];
};

export default getColumns;
